module.exports = __webpack_public_path__ + "static/img/jx.238d69d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jx.png
// module id = kRbI
// module chunks = 1